import React, {Component} from 'react';

export default class WeexModal extends Component {

    state = {
        visivel:true
    }

    constructor(props) {
        super(props)
        
        this.setState({visivel:props.visivel})
    }

    

    ocultar = (event) => {
        this.props.callback()

    }

    render() {

        

        return (
            <div className={this.state.visivel === true ? 'modal is-active' : 'modal'}>
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                    <p className="modal-card-title">{this.props.titulo}</p>
                    <button onClick={this.ocultar} className="delete" aria-label="close"></button>
                    </header>
                    <section className="modal-card-body">
                    {this.props.conteudo}
                    </section>
                    <footer className="modal-card-foot" style={{textAlign:'center'}}>
                        <button className="weex-button" onClick={this.ocultar}>Ok</button>
                        
                    </footer>
                </div>
            </div>
        )
    }
}